import React, { FC } from "react";
import { Heading, Icon } from "@telia/teddy";
import cn from "classnames";
import "./CollapsibleStep.less";

interface Props {
    children: React.ReactNode;
    isDisabled?: boolean;
    label: string;
    onClick: () => void;
    selectedStep: string | undefined;
    stepId: string;
}

const CollapsibleStep: FC<Props> = ({ label, isDisabled, onClick, stepId, selectedStep, children }) => {
    if (stepId === selectedStep) {
        return (
            <div className="collapsible-step collapsible-step__content">
                <Heading mb="100" as="h2" variant="title-100" className="collapsible-step__heading">
                    {label}
                </Heading>
                <div>{children}</div>
            </div>
        );
    }

    if (isDisabled) {
        return (
            <div
                className={cn("collapsible-step", {
                    "collapsible-step__disabled": true,
                })}
            >
                <Heading mb="100" as="h3" variant="title-100" className="collapsible-step__disabled-heading">
                    {label}
                </Heading>
            </div>
        );
    }

    return (
        <button className="collapsible-step collapsible-step--editable" onClick={onClick}>
            <div className="collapsible-step__collapser-left-wrapper">
                <div className="collapsible-step__collapser-icon">
                    <Icon name="check-circle" size="md" aria-hidden="true" focusable="false" />
                </div>
                <Heading mb="100" as="h3" variant="title-100" className="collapsible-step__collapser-heading">
                    {label}
                </Heading>
            </div>
            <div className="collapsible-step__edit-btn">
                <span className="collapsible-step__edit-btn-text">Endre</span>
                <span className="collapsible-step__edit-btn-icon">
                    <Icon name="edit" size="xs" aria-hidden="true" focusable="false" />
                </span>
            </div>
        </button>
    );
};

export default CollapsibleStep;
